import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplateService } from 'app/_services/template.service';
import { TokenStorageService } from '../../_services/token-storage.service';

@Component({
  selector: 'app-edit-template',
  templateUrl: './edit-template.component.html'
})
export class EditTemplateComponent implements OnInit {
  contactUUID: string = "";
  templateId: number = 0;
  templateInfo: any = {};

  editTemplateForm: FormGroup = new FormGroup({
    template_name: new FormControl(""),
    template_content: new FormControl("")
  })

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private template: TemplateService,
    private tokenStorage: TokenStorageService,
  ) { }

  ckEditorWithImageConfig = {
    'default': {
        'versionCheck': false
    }
  };

  ngOnInit(): void {
    this.contactUUID = this.tokenStorage.getToken() || "";
    this.templateId = this.activatedRoute.snapshot.params['templateid'];
   
    this.template.getTemplate$(this.templateId, this.contactUUID).subscribe((template: {}) => {
      this.templateInfo = template;
    })
  }

  readyCKEditor(event:any) {
    console.log('***********');
    event.editor.config.versionCheck = false;
    console.log('********************window[CKEDITOR]', event.editor.config.versionCheck );
  }

  onSubmit(values: any): void {
    let templateInfo = {
      "template_type_id": this.templateInfo.template_type_id,
      "active": this.templateInfo.active,
      "template_id": this.templateInfo.template_id,
      "template_name": values.template_name !== "" ? values.template_name : this.templateInfo.template_name,
      "template": values.template_content !== "" ? values.template_content : this.templateInfo.template,
      "updated": this.templateInfo.updated
    }

    this.template.updateTemplate$(this.contactUUID, templateInfo).subscribe({
      next: (data:any) => {
        console.log("Success updating the template ", data);
        this.router.navigate(['/maquettes']);
      },
      error: (err: any) => {
        console.log("Something went wrong updating the template: ", err)
      }
    })
  }

}
